export default {"src":"/_next/static/media/apple-pay.2bb0a2d7.svg","height":20,"width":49,"blurWidth":0,"blurHeight":0};